<template>
    <svg :width="width" :height="height" viewBox="0 0 24 24" :fill="fillColor" xmlns="http://www.w3.org/2000/svg"
        :class="className">
        <path
            d="M14.561 8.89577L15.4814 12.1728L12.6403 14.1074L11.7199 10.8304L14.561 8.89577ZM5.59744 5.71747L4.93717 6.03332C4.52368 6.20441 4.24356 6.49711 4.09684 6.9114C3.95011 7.3257 3.97012 7.7371 4.15686 8.14561L5.59744 11.2252V5.71747ZM8.79872 4C8.35854 4 7.98186 4.15793 7.66867 4.47378C7.35547 4.78964 7.19861 5.16472 7.19808 5.59902V10.3171L9.33894 4.51327C9.37895 4.42114 9.4123 4.33218 9.43898 4.24637C9.46565 4.16056 9.51234 4.07844 9.57903 4H8.79872ZM12.9204 4.09871C12.5069 3.95394 12.0934 3.97368 11.6799 4.15793C11.2664 4.34218 10.9863 4.63829 10.8395 5.04627L7.29812 14.6996C7.15139 15.1076 7.1714 15.5124 7.35814 15.9141C7.54488 16.3158 7.845 16.5887 8.2585 16.7329L14.2809 18.9045C14.6944 19.0492 15.1047 19.0295 15.5118 18.8452C15.9189 18.661 16.1955 18.3649 16.3417 17.9569L19.9032 8.30354C20.0499 7.89556 20.0299 7.49074 19.8431 7.08907C19.6564 6.68741 19.3563 6.41446 18.9428 6.27022L12.9204 4.09871Z"
            :fill="fillColor" />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CardsIcon',
    props: {
        fillColor: {
            type: String,
            default: '#fff'
        },
        width: {
            type: [Number, String],
            default: 24
        },
        height: {
            type: [Number, String],
            default: 24
        },
        class: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const className = props.class;
        return {
            className
        };
    }
});
</script>